export const GOTO_RESOLVE_ROUTER_BASENAME = '/antivirus';
export const LOCAL_ROUTER_BASENAME = '/';
export const LOCAL_HOSTNAME = 'localhost';
